module.exports = __webpack_public_path__ + "img/logo_stf_transparent_black.c007a6b6.png";